import { cn } from '@/lib/utils'

export function Skeleton({ className }: { className?: string }) {
  return (
    <div
      aria-hidden
      className={cn('rounded bg-muted-foreground/15 animate-pulse', className)}
    />
  )
}

export function ListRowSkeleton() {
  return (
    <div className="flex items-center gap-3 px-2.5 py-1.5">
      <Skeleton className="h-1.5 w-1.5 rounded-full" />
      <div className="flex-1 space-y-1.5">
        <Skeleton className="h-3 w-2/3" />
        <Skeleton className="h-2 w-1/3" />
      </div>
    </div>
  )
}

export function ListSkeleton({ rows = 5 }: { rows?: number }) {
  return (
    <div className="divide-y divide-border rounded border border-border">
      {Array.from({ length: rows }).map((_, i) => <ListRowSkeleton key={i} />)}
    </div>
  )
}

export function DetailSkeleton() {
  return (
    <div className="p-6 space-y-6">
      <Skeleton className="h-6 w-1/2" />
      <div className="space-y-3">
        <Skeleton className="h-3 w-1/4" />
        <Skeleton className="h-4 w-4/5" />
        <Skeleton className="h-4 w-3/5" />
      </div>
      <Skeleton className="h-24 w-full" />
    </div>
  )
}
